import { render, staticRenderFns } from "./deletePrinterRule.vue?vue&type=template&id=08f7d324&scoped=true"
import script from "./deletePrinterRule.vue?vue&type=script&lang=js"
export * from "./deletePrinterRule.vue?vue&type=script&lang=js"
import style0 from "./deletePrinterRule.vue?vue&type=style&index=0&id=08f7d324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f7d324",
  null
  
)

export default component.exports